import type { FieldPath, FieldValues } from "react-hook-form";
import {
  CdcTextInputField,
  type CdcTextInputFieldProps,
} from "./cdc-field-helpers";

export type CdcFirstNameFieldProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = Omit<
  CdcTextInputFieldProps<TFieldValues, TName>,
  "autoComplete" | "fieldKey" | "inputMode" | "maxLength" | "pattern" | "type"
>;

export function CdcFirstNameField<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
>({
  required = false,
  ...props
}: Readonly<CdcFirstNameFieldProps<TFieldValues, TName>>) {
  return (
    <CdcTextInputField
      {...props}
      autoComplete="given-name"
      fieldKey="firstName"
      required={required}
      type="text"
    />
  );
}
